export default __webpack_public_path__ + "img/5a1df42cdfc6853177c8abc2a58c03bd-woods.jpg";